import { Css, Filters, multiFilter, useBreakpoint } from "@homebound/beam";
import { useState } from "react";
import { NamedFragment } from "src/fragments/commonFragments.generated";
import { ProjectChangeEventGraphType } from "src/generated/graphqlTypes";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";
import { useVarianceTabQuery } from "./VarianceTab.generated";
import { BudgetMetricsViewType, getFromDate, ViewTypeFilter } from "./utils";
import { TopChangeEventsWidget } from "./widgets/TopChangeEventsWidget";

type FilterOptions = { project?: string[] };

export function VarianceTab() {
  const { projectId } = useRouteParams<ProjectParams>();
  const { mdAndDown } = useBreakpoint();
  const [viewType, setViewType] = useState(BudgetMetricsViewType.ALL_TIME);
  const [filter, setFilter] = useState<FilterOptions>({});
  const query = useVarianceTabQuery({
    variables: { projectId, filter: { fromDate: getFromDate(viewType), projectIds: filter.project } },
  });

  return queryResult(query, ({ project, projectChangeEventGraphs }) => {
    const [reasonGraphData, divisionGraphData] = projectChangeEventGraphs.graphs
      .partition((graph) => graph.type === ProjectChangeEventGraphType.Reason)
      .map((graphs) => graphs.flatMap((g) => g.data));
    return (
      <div>
        <div css={Css.df.mb2.$}>
          <div css={Css.df.cg1.$}>
            <Filters
              filterDefs={getFilterDefs([project, ...project.childrenRecursive])}
              filter={filter}
              onChange={setFilter}
            />
          </div>
          <ViewTypeFilter viewType={viewType} setViewType={setViewType} />
        </div>
        <div css={Css.df.cg3.if(mdAndDown).fdc.gap2.$}>
          <TopChangeEventsWidget data={reasonGraphData} type={ProjectChangeEventGraphType.Reason} />
          <TopChangeEventsWidget data={divisionGraphData} type={ProjectChangeEventGraphType.CostDivision} />
        </div>
      </div>
    );
  });
}

function getFilterDefs(data: NamedFragment[]) {
  return {
    project: multiFilter({
      options: data,
      getOptionValue: (p) => p.id,
      getOptionLabel: (p) => p.name,
      label: "Project",
    }),
  };
}
